import { useAuthStore } from '@/stores/auth'
import type { TGeneral } from '~/types/app.type'
import type { THubSpotUser } from '~/models/hubspot'
import { logError } from '~/utils/log-error'

export const useHubSpotUser = () => {
  const { $restClient }: TGeneral = useNuxtApp()
  const authStore = useAuthStore()
  const { hubSpotUser } = storeToRefs(authStore)

  const fetchUserInfo = async () => {
    try {
      const response = await $restClient.getUserInfoHubspot()
      authStore.setHubSpotUser(response)
    } catch (e) {
      logError(e)
      authStore.setHubSpotUser(null)
    }
  }

  const setUserInfo = async (user: THubSpotUser) => {
    try {
      await $restClient.setUserInfoHubspot(user)
      authStore.setHubSpotUser({ ...hubSpotUser.value, ...user })
    } catch (e) {
      logError(e)
      authStore.setHubSpotUser(null)
    }
  }

  return {
    hubSpotUser,
    fetchUserInfo,
    setUserInfo,
  }
}
